import { connectHits } from 'instantsearch.js/es/connectors'
import { get, getAll } from '@bigyouth/base'
import trainingSearch from './trainingSearch'

const renderHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams } = renderOptions

  if (hits.length !== 0) {
    widgetParams.container.innerHTML = '<ul class="row"></ul>'

    hits.forEach((hit) => {
      // create li element, add classes
      const li = document.createElement('li')
      li.classList.add('col-12')
      li.classList.add('md-col-6')
      li.classList.add('lg-col-4')
      li.classList.add('mb-6')
      li.classList.add('flex')

      let location = null
      let nextSession = null
      const level = false

      if (hit.courses) {
        const locations = Array.from(
          new Set(
            hit.courses.map((course) =>
              course.location.address
                ? course.location.address.city.toLowerCase()
                : '',
            ),
          ),
        )
        location = locations.join('/')

        if (hit.next_session !== null) {
          nextSession = new Date(hit.next_session).toLocaleDateString('fr')
        }
      }

      li.innerHTML = `
      <div class="w-full relative flex">
        <a class="training-card__link" href="/${hit.path}" js-training-list-card><span class="sr-only">Voir la formation</span></a>
        <div class="training-card training-card--full">
          <div class="flex items-center justify-between mb-4">
            <div class="flex items-center flex-shrink-0">
              <p class="tracking-tight text-dark-blue">Réf : ${hit.ref}</p>
              ${hit.is_new ? '<p class="new-mention ml-4">Nouveau !</p>' : ''}
            </div>
            ${hit.training_diploma !== 'Attestation de fin de formation'
              ? `<p class="tag-type ml-2">${hit.training_diploma}</p>`
              : ''
            }
          </div>
      
          <h3 class="title-4 title-4--dark-blue">${hit.name}</h3>
          ${level ? '<p class="title-4 title-4--dark-blue title-4--xsmall mt-2">Niveau 2 : Perfectionnement 2</p>' : ''}
      
          <div class="training-card__infos">
            <div class="flex items-center mb-2">
              <svg width="32" height="32" class="mr-4 flex-shrink-0">
                <use href="#icon-days2" xlink:href="#icon-days2"></use>
              </svg>
              <p class="subtitle">${hit.training_number_of_days} jour${hit.training_number_of_days > 1 ? 's' : ''}</p>
            </div>
    
            <div class="flex items-center mb-2">
              <svg width="32" height="32" class="mr-4 flex-shrink-0">
                <use href="#icon-method" xlink:href="#icon-method"></use>
              </svg>
              <p class="subtitle">${hit.training_modality}</p>
            </div>

            ${location && hit.training_modality !== 'Distanciel'
            ? `<div class="flex items-center">
                <svg width="32" height="32" class="mr-4 flex-shrink-0">
                  <use href="#icon-location2" xlink:href="#icon-location2"></use>
                </svg>
                <p class="subtitle subtitle--location">${location}</p>
              </div>`
            : ''
            }
          </div>
      
          <div class="flex ${hit.price_ht !== null ? 'justify-between' : 'justify-end'} items-end">
            <div class="pricing flex-shrink-0 pr-3">
              ${hit.price_ht !== null
              ? `<p><span class="pricing__price">${hit.price_ht} €</span> <sup class="pricing__sup">HT</sup></p>
                <p class="pricing__mention">par participant</p>`
              : ''}
            </div>
            <div>
              ${nextSession
              ? `<p class="text-center text-12 tracking-tight2 mb-2">
                  Prochaine session le : ${nextSession}
                </p>`
              : ''
              }
              <a href="/${hit.path}#next-sessions" js-training-list-card class="button w-full relative z-2">
                ${nextSession
                ? `<svg class="icon icon--white">
                  <use href="#icon-subscription" xlink:href="#icon-subscription"></use>
                </svg>

                S'inscrire`
              : 'En savoir plus'}
              </a>
            </div>
          </div>
        </div>
      </div>
      `

      get('ul', widgetParams.container).appendChild(li)
      getAll('a', li).forEach(link => {
        link.addEventListener('click', (e) => {
          trainingSearch.saveFilters(renderOptions.instantSearchInstance)
        })
      })
    })
  } else {
    widgetParams.container.innerHTML =
      "Il n'y a pas de formation avec ces critères de recherche"
  }
}

const customHits = connectHits(renderHits)

export default customHits
